import { Box } from "@mui/material";
import {
  NumberField,
  SelectFieldComponent,
  TextFieldComponent,
} from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import InputValidationUtils from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/InputValidationUtils";
import { countries } from "../../utils/Countries";
import RoleUtils from "../../utils/RoleUtils";
import { userRoles } from "../../utils/UserRolesUtils";
import { DateFieldComponent } from "../DatePicker";
import WelcomeFormFields from "../PersonalInfo/WelcomeFormFields";

interface Props {
  control: any;
  register: any;
  errors: any;
  canEdit: boolean;
  isVacationReportEnabled: boolean | undefined;
}

export const UserUpdateModal = ({ control, register, errors, canEdit, isVacationReportEnabled }: Props) => {
  return (
    <>
      <TextFieldComponent propertyName={"email"} label="Email" required={true} readOnly={!RoleUtils.isAdmin()} />
      {canEdit && (
        <DateFieldComponent
          control={control}
          register={register}
          errors={errors}
          format={"dd/MMM/yyyy"}
          propertyName={"shortStart"}
          label="Joined"
          required={true}
          readOnly={!RoleUtils.isAdmin()}
          toUTC
        />
      )}

      <TextFieldComponent
        control={control}
        register={register}
        errors={errors}
        propertyName={"firstName"}
        label="First Name"
        readOnly={!RoleUtils.isAdmin()}
      />
      <TextFieldComponent
        control={control}
        register={register}
        errors={errors}
        propertyName={"lastName"}
        label="Last Name"
        readOnly={!RoleUtils.isAdmin()}
      />

      <DateFieldComponent
        control={control}
        register={register}
        errors={errors}
        format={"dd/MMM"}
        propertyName={"shortBirthday"}
        label="Day Of Birth"
        views={["month", "day"]}
        openTo={"day"}
        clearable
        toUTC
        disableToolbar
      />
      <TextFieldComponent propertyName={"phone"} label="Phone" />
      {RoleUtils.isAdmin() && (
        <>
          <SelectFieldComponent
            control={control}
            register={register}
            errors={errors}
            propertyName={"primaryRole"}
            label={"Primary Role"}
            required={true}
            options={userRoles}
          />
          <SelectFieldComponent
            control={control}
            register={register}
            errors={errors}
            propertyName={"secondaryRole"}
            label={"Secondary Role"}
            required={false}
            options={userRoles}
          />
        </>
      )}
      <SelectFieldComponent
        control={control}
        register={register}
        errors={errors}
        propertyName={"country"}
        label={"Country"}
        defaultValue={"ARGENTINA"}
        required={true}
        options={countries}
      />
      <TextFieldComponent control={control} register={register} errors={errors} propertyName={"region"} label="Region" />
      <TextFieldComponent control={control} register={register} errors={errors} propertyName={"slackUserId"} label="Slack User Id" />

      <span style={{ marginLeft: "10px" }}>Slack → Profile → More → Copy Member ID</span>
      <TextFieldComponent control={control} register={register} errors={errors} propertyName={"githubUsername"} label="Github Username" />
      {isVacationReportEnabled && RoleUtils.isAdmin() && (
        <NumberField
          control={control}
          register={register}
          errors={errors}
          propertyName={"additionalVacationsAmount"}
          label="Additional Vacations Amount (days)"
          pattern={InputValidationUtils.numberRegex()}
          min={0}
          max={100}
          required={true}
          readOnly={!RoleUtils.isAdmin()}
        />
      )}

      {isVacationReportEnabled && RoleUtils.isAdmin() && (
        <DateFieldComponent
          control={control}
          register={register}
          errors={errors}
          format={"dd/MMM/yyyy"}
          propertyName={"vacationsComputedSince"}
          label="Vacations Computed Since"
          required={true}
          readOnly={!RoleUtils.isAdmin()}
          toUTC
        />
      )}
      {isVacationReportEnabled && RoleUtils.isAdmin() && (
        <NumberField
          control={control}
          register={register}
          errors={errors}
          propertyName={"initialTakenVacations"}
          label="Initial Taken Vacations (days)"
          pattern={InputValidationUtils.numberRegex()}
          min={0}
          max={100}
          required={true}
          readOnly={!RoleUtils.isAdmin()}
        />
      )}
      {isVacationReportEnabled && RoleUtils.isAdmin() && (
        <NumberField
          control={control}
          register={register}
          errors={errors}
          propertyName={"vacationAccumulation"}
          label="Vacation Accumulation per year (days)"
          pattern={InputValidationUtils.numberRegex()}
          min={0}
          max={30}
          required={true}
          readOnly={!RoleUtils.isAdmin()}
        />
      )}
      <WelcomeFormFields control={control} register={register} errors={errors} />
    </>
  );
};
